import { render, staticRenderFns } from "./JobAssignmentPage.vue?vue&type=template&id=07465056&"
import script from "./JobAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports